import { render } from "./MasterComponent.vue?vue&type=template&id=0d8ad8e0&scoped=true&ts=true"
import script from "./MasterComponent.vue?vue&type=script&lang=ts"
export * from "./MasterComponent.vue?vue&type=script&lang=ts"

import "./MasterComponent.vue?vue&type=style&index=0&id=0d8ad8e0&lang=scss&scoped=true"

import exportComponent from "/root/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8ad8e0"]])

export default __exports__